import React, { useEffect, useState } from "react";
import './FaultFirstPageCustom_bus.css';
import { ThreeCircles } from 'react-loader-spinner';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import value from "wink-statistics/src/accessor";

const TOP_KPIS_FIRST_PAGE = {
  totalvehiclecount: 0,
  fault_active_duration: 0,
  vehicle_with_fault: 0,
  vehicle_with_alarm: 0,
  vehicle_with_dtc: 0,
};

export default function FaultFirstPageKpis({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const [faultactive, setFaultActive] = useState(TOP_KPIS_FIRST_PAGE);
  const [vehiclewithfaults, setVehicleWithFaults] = useState(TOP_KPIS_FIRST_PAGE);
  const [vehiclewithalarm, setVehicleWithAlarm] = useState(TOP_KPIS_FIRST_PAGE);
  const [vehiclewithdtc, setVehicleWithDtc] = useState(TOP_KPIS_FIRST_PAGE);
  const [timeDuration, setTimeDuration] = useState(0);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;

    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        totalvehiclecount: temp_result.vehicle_count.value
      }
      setTopData((prestate) => responce);
    }

  }

  function GFG_Fun(minutes) {
    let n = Math.abs(minutes / 3600)
    //return n;
    return n - Math.floor(n);
  }

  function toTime(minute) {
    if (minute === undefined || minute === 0) {
      return 0
    } else {
      let minutes = Math.floor(minute / vehiclewithfaults.vehicle_with_fault)
      let a = GFG_Fun(minutes)
      let mm = Math.round(a * 60)
      var h = Math.floor(minutes / 3600);
      // var m = minutes % 3600;
      // var m = Math.floor(minutes / 60);
      h = h < 10 ? '0' + h : h;
      // m = m < 10 ? '0' + m : m;
      return `${h}h ${mm}min`
    }
  }
  const faultActive = (data) => {
    const res_result = data;

    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        fault_active_duration: temp_result.duration.value
      }
      setFaultActive((prestate) => responce);
    }
  }
  const vehicleWithFaults = (data) => {
    const res_result = data;

    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        vehicle_with_fault: temp_result.vehicle_count.value
      }
      setVehicleWithFaults((prestate) => responce);
    }

  }
  const vehicleWithAlarm = (data) => {
    const res_result = data;

    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        vehicle_with_alarm: temp_result.vehicle_count.value
      }
      setVehicleWithAlarm((prestate) => responce);
    }

  }
  const vehicleWithDtc = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        vehicle_with_dtc: temp_result.vehicle_count.value
      }
      setVehicleWithDtc((prestate) => responce);
    }
  }
  useEffect(() => {

    fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/topkpisfirstpage_bus", body: { filterdata: gloablfilter } }, appyData)
    fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/faultalertduration_bus", body: { filterdata: gloablfilter } }, faultActive)
    fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/faultalertoccdur_bus", body: { filterdata: gloablfilter } }, vehicleWithFaults)
    fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/faultalarm_bus", body: { filterdata: gloablfilter } }, vehicleWithAlarm)
    fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/faulwithdtc_bus", body: { filterdata: gloablfilter } }, vehicleWithDtc)
  }, [gloablfilter])

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)
  return (
    <>
      <section className="kpi my-3">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-12 col-lg-7 pl-4">
            <div className="row">
              <div className="col-md-6 col-sm-12 col-lg-4 pl-0" style={{ paddingLeft: "6px" }}>
                <div className="widget_bus p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/EV-Logo_iconB.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0 highBold">{topdata.totalvehiclecount}</p>
                      <p className="m-0"><small className="text-mutedf">Total Vehicle Count</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-4 pl-0 evtpks-pl0">
                <div className="widget_bus p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/fault_bus/fault_bus_duration.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0 highBold">{toTime(faultactive.fault_active_duration)}</p>
                      <p className="m-0"><small className="text-mutedf">Fault Duration/Vehicle</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-4 pl-0 evtpks-pl0">
                <div className="widget_bus p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/fault_bus/vehicle_with_fault.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0 highBold">{vehiclewithfaults.vehicle_with_fault}</p>
                      <p className="m-0"><small className="text-mutedf">Vehicles With Fault</small></p>
                    </div></>)}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-12 col-lg-5 pl-4 evtpks-pl0">
            <div className="row">
              <div className="col-md-6 col-sm-12 pl-0">
                <div className="widget_bus p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/fault_bus/fault_bus_alarm.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0 highBold">{vehiclewithalarm.vehicle_with_alarm}</p>
                      <p className="m-0"><small className="text-mutedf">Vehicles With Alarm</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-6 col-sm-12 pl-0 evtpks-pl0">
                <div className="widget_bus p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"../../../assets/img_Bus/fault_bus/fault_bus_imbalance.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0 highBold">{vehiclewithdtc.vehicle_with_dtc}</p>
                      <p className="m-0"><small className="text-mutedf">Vehicles With Current Imbalance</small></p>
                    </div></>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
